export default __webpack_public_path__ + "static/media/leader_notes.253d8c7c.pdf";